export class OrderLine {
   constructor(product_id, product_code, product_name, pieces, boxes, unit_price, subtotal, ieps, iva, total, precio_u){
      this.product_id = product_id
      this.product_code = product_code
      this.product_name = product_name
      this.pieces = pieces
      this.boxes = boxes
      this.unit_price = unit_price
      this.subtotal = subtotal
      this.ieps = ieps
      this.iva = iva
      this.total = total
      this.precio_u = precio_u
   }
   static fromServiceOrderLines (line) {
      return new OrderLine(
         line.id_producto,
         line.codigo_producto,
         line.nombre_producto,
         line.piezas,
         line.cajas,
         line.precio_unitario,
         line.subtotal,
         line.ieps,
         line.iva,
         line.total,
         line.precio_u
         );
   }   
}